export const TABLE_SELECTION_CREATE_TABLE_ACTION = "TABLE_SELECTION_CREATE_TABLE";
export const TABLE_SELECTION_CLEAR_TABLE_ACTION = "TABLE_SELECTION_CLEAR_TABLE";
export const TABLE_SELECTION_TOGGLE_ROWS_ACTION = "TABLE_SELECTION_TOGGLE_ROWS";
export const TABLE_SELECTION_SET_SELECTED_ROWS_ACTION = "TABLE_SELECTION_SET_SELECTED_ROWS";
export const TABLE_SELECTION_SET_SELECTED_ROW_ACTION = "TABLE_SELECTION_SET_SELECTED_ROW";
export const TABLE_SELECTION_UNSET_SELECTED_ROWS_ACTION = "TABLE_SELECTION_UNSET_SELECTED_ROWS";
export const TABLE_SELECTION_UNSET_SELECTED_ROW_ACTION = "TABLE_SELECTION_UNSET_SELECTED_ROW";
